import { ApplicationDate } from './ApplicationDate.jsx';
import { InputRow } from './InputRow.jsx';
import { LimeFieldInputs as Legacy } from './legacy/LimeFieldInputs.jsx';
import { SoilDate } from './SoilDate.jsx';

export function LimeFieldInputs({ instance }) {
  const rx = instance.lime;
  const inputs = instance.inputs.lime;

  if (!inputs) return <Legacy instance={instance} />;

  return (
    <>
      <SoilDate rx={rx} />
      <InputRow name="Tillage Type" value={inputs.tillageType} />
      <InputRow name="Ref Lime Quality" value={inputs.referenceQuality} />
      <InputRow name="Lime Quality" value={inputs.quality} />
      <ApplicationDate type="L" inputs={inputs} />
    </>
  );
}
